import { createContext, useContext, useEffect } from 'react';

export const MarqueePauseContext = createContext<((active: boolean) => void) | null>(null);

export function useMarqueePause(active: boolean) {
  const setPaused = useContext(MarqueePauseContext);
  useEffect(() => {
    if (!setPaused) return;
    if (active) setPaused(true);
    return () => setPaused(false);
  }, [active, setPaused]);
}
